export var getDefaultTimezone = function getDefaultTimezone(state) {
  return state.timezone.defaultTimezoneForQuery;
};
export var getTimezoneSelectionDisabled = function getTimezoneSelectionDisabled(state) {
  return state.timezone.timezoneSelectionDisabled;
};
export var getTimezonesLoading = function getTimezonesLoading(state) {
  return state.timezone.isLoading;
};
export var getTimezones = function getTimezones(state) {
  return state.timezone.timezones;
};
export var getTimezoneState = function getTimezoneState(state) {
  return state.timezone;
};